module.exports = __webpack_public_path__ + "img/keepkey.02c093e6.jpg";